import React from "react";
import { useLocation, Link } from "wouter";
import { cn } from "@/lib/utils";

const steps = [
  { label: "Introduction", route: "/maturity/introduction" },
  { label: "Assessment Questions", route: "/maturity/questions" },
  { label: "Implementation Blockers", route: "/maturity/blockers" },
  { label: "Results", route: "#" } // Will be handled by parent component
];

interface StepperTrailProps {
  activeIndex: number;
}

export const StepperTrail = ({ activeIndex }: StepperTrailProps) => {
  return (
    <div className="flex justify-between items-center mb-8">
      {steps.map((step, index) => {
        const isActive = index === activeIndex;
        const isComplete = index < activeIndex;

        return (
          <div key={step.label} className="flex-1 flex flex-col items-center text-center relative">
            <div
              className={cn(
                "rounded-full w-6 h-6 flex items-center justify-center border-2",
                isActive ? "border-primary text-primary" :
                isComplete ? "border-primary text-primary bg-primary/10" :
                "border-muted text-muted-foreground"
              )}
            >
              {isComplete ? "✓" : index + 1}
            </div>
            <span className={cn("text-sm mt-2", isActive ? "text-primary font-semibold" : "text-muted-foreground")}>
              {step.label}
            </span>
            {index < steps.length - 1 && (
              <div className="absolute top-3 left-full w-full h-0.5 bg-border z-[-1]"></div>
            )}
          </div>
        );
      })}
    </div>
  );
};